export interface KatanaOptions {
  src: string;
  width: number;
  quality?: number;
}

const normalizeSrc = (src: string): string => {
  return src[0] === '/' ? src.slice(1) : src;
};

export default function katana({ src, width, quality }: KatanaOptions) {
  const params = [`w=${width}`];
  if (quality) {
    params.push(`q=${quality}`);
  }
  const paramsString = params.join(',');
  return `https://katana.bdatrip.com/image/${paramsString}/${normalizeSrc(src)}`;
}
